// extracted by mini-css-extract-plugin
export default {"main":"GLinkCont_main__j6nEp","content":"GLinkCont_content__wpE7W","title":"GLinkCont_title__9GH2t","itemCont":"GLinkCont_itemCont__RNTC7"};